import { EditTabsPattern } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'

import { ConfigData, History, Settings } from './tabs'

const tabs = [
  { component: <Settings />, name: 'settings' },
  { component: <History />, name: 'version' },
  { component: <ConfigData />, name: 'config' },
]

export const AuthCode = () => {
  const { componentID, useUrl } = useComponentProvider()
  return (
    <EditTabsPattern
      defaultTab="settings"
      showTabs={!!componentID}
      tabs={tabs}
      urlParams={useUrl}
    />
  )
}
